import analyticsService from 'services/AnalyticsService';
import { profileSelector } from 'store/profile/selectors';
import { Dispatch } from 'redux';
import { RootState } from 'store/types';

export const IDENTIFY_USER = '[Analytics] Identify User';
export const USER_IDENTIFIED = '[Analytics] User Identified';
export const identifyUser = () => (dispatch: Dispatch, getState: () => RootState) => {
  dispatch({ type: IDENTIFY_USER });

  const userProfile = profileSelector(getState());
  analyticsService.identifyUser(userProfile);

  return dispatch({ type: USER_IDENTIFIED });
};
